import { memo } from "react";
import { DynamicIcon } from "@funnel-ui/primitives/DynamicIcon";
import { StepHeading } from "@funnel-ui/primitives/StepHeading";
import { TestimonialCarousel, type Testimonial } from "@funnel-ui/primitives/TestimonialCarousel";

type TrustItem = {
  icon: string;
  text: string;
};

type TrustScreenProps = {
  headline: string;
  description?: string;
  privacyItems?: TrustItem[];
  testimonials?: Testimonial[];
  className?: string;
  testId?: string;
};

const TrustScreenImpl = ({
  headline,
  description,
  privacyItems,
  testimonials,
  className,
  testId,
}: TrustScreenProps) => (
  <section data-testid={testId} className={`flex flex-col gap-6 ${className ?? ""}`}>
    <StepHeading title={headline} description={description} align="center" />
    {privacyItems && privacyItems.length > 0 && (
      <ul className="flex flex-col gap-2">
        {privacyItems.map((item, index) => (
          <li
            key={index}
            className="flex items-start gap-3 rounded-xl p-3"
            style={{
              background: "hsl(var(--hero-success) / 0.06)",
            }}
          >
            <span
              className="mt-0.5 inline-flex shrink-0"
              style={{ color: "hsl(var(--hero-success))" }}
            >
              <DynamicIcon icon={item.icon} size={18} />
            </span>
            <span className="flex-1 text-sm" style={{ color: "hsl(var(--brand-bg-foreground))" }}>
              {item.text}
            </span>
          </li>
        ))}
      </ul>
    )}
    {testimonials && testimonials.length > 0 && (
      <div className="mt-2">
        <TestimonialCarousel items={testimonials} />
      </div>
    )}
  </section>
);

export const TrustScreen = memo(TrustScreenImpl);

export default TrustScreen;
